import React from 'react';
import './StatisticsCard.css';

function StatisticsCard({ statistics }) {
  if (!statistics) {
    return <div className="loading">Loading statistics...</div>;
  }

  return (
    <div className="statistics-grid">
      <div className="stat-card">
        <div className="stat-label">Total Trades</div>
        <div className="stat-value">{statistics.total_trades || 0}</div>
      </div>

      <div className="stat-card">
        <div className="stat-label">Winners</div>
        <div className="stat-value positive">{statistics.winners || 0}</div>
      </div>

      <div className="stat-card">
        <div className="stat-label">Losers</div>
        <div className="stat-value negative">{statistics.losers || 0}</div>
      </div>

      <div className="stat-card">
        <div className="stat-label">Win Rate</div>
        <div className="stat-value">
          {statistics.win_rate ? `${statistics.win_rate.toFixed(2)}%` : '0%'}
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-label">Avg Hold Time</div>
        <div className="stat-value">
          {statistics.average_hold_time ? `${statistics.average_hold_time} days` : '0 days'}
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-label">Avg Gain</div>
        <div className="stat-value positive">
          {statistics.average_gain ? `${statistics.average_gain.toFixed(2)}%` : '0%'}
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-label">Avg Loss</div>
        <div className="stat-value negative">
          {statistics.average_loss ? `${statistics.average_loss.toFixed(2)}%` : '0%'}
        </div>
      </div>
    </div>
  );
}

export default StatisticsCard;
